import { useSelector } from "react-redux";
import { AppState } from "store";
import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";

function useReceiptPermissions() {
  const { hasRelation } = useCheckRelations();
  const receiptCreator = useSelector((state: AppState) => state.auth.selectedCompany.receiptCreator);
  const receiptViewer = useSelector((state: AppState) => state.auth.selectedCompany.receiptViewer);

  const getReceiptAdminPermissions = (overrideAdmin: boolean = true) => {
    return hasRelation(AuthEnums.PersonCompanyRelationType.ReceiptsAdmin, overrideAdmin);
  };

  return {
    receiptCreator,
    receiptViewer,
    getReceiptAdminPermissions,
    hasReceiptChartPermissions: receiptCreator,
  };
}

export default useReceiptPermissions;
